module.exports = __webpack_public_path__ + "img/0e3c3af.webp";